export enum PhonePlatform {
  Krdya = 'krdya',
  Knox_krdya = 'knox-krdya',
  Nuovo_krdya = 'nuovo-krdya',
  Trustonic = 'trustonic',
  Trustonic_prepaid = 'trustonic-prepaid',
  Datacultr = 'datacultr',
  Knox = 'knox',
  Nuovo = 'nuovo',
  Absolute = 'absolute'
}